import { render, staticRenderFns } from "./PlaybackPlayer.vue?vue&type=template&id=3865529e&scoped=true&"
import script from "./PlaybackPlayer.vue?vue&type=script&lang=js&"
export * from "./PlaybackPlayer.vue?vue&type=script&lang=js&"
import style0 from "./PlaybackPlayer.vue?vue&type=style&index=0&id=3865529e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3865529e",
  null
  
)

export default component.exports